import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import ConfirmationModal from '../../../common/modal/ConfirmationModal'
import { deleteDriverMovementHistory } from '../../../../actions'

const DeleteDriverMovementHistoryButton = ({
  driverMovementHistoryId,
  dispatchDeleteDriverMovementHistory
}) => {
  const [showWarningModal, setShowWarningModal] = useState(false)

  const closeModal = () => setShowWarningModal(false)

  const handleDelete = () => {
    dispatchDeleteDriverMovementHistory(driverMovementHistoryId)
    closeModal()
  }

  return (
    <>
      <ConfirmationModal
        show={showWarningModal}
        onClickConfirm={handleDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={() => setShowWarningModal(true)} className="mr-2">
        Eliminar
      </Button>
    </>
  )
}

DeleteDriverMovementHistoryButton.propTypes = {
  driverMovementHistoryId: PropTypes.string.isRequired,
  dispatchDeleteDriverMovementHistory: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
  dispatchDeleteDriverMovementHistory: deleteDriverMovementHistory
}

export default connect(null, mapDispatchToProps)(DeleteDriverMovementHistoryButton)